const config = {
  lang: ['en', 'ru', 'fr', 'de'],
  sitekey: '6Le6k-MZAAAAACVZrKFaHuCLzTkX_rZdsxTYTrTI',
  port: '8851',
  host: 'localhost',
  url: 'http://localhost:8851',
};

export default config;
